import RadioButtonCheckedOutlinedIcon from "@mui/icons-material/RadioButtonCheckedOutlined";
import RadioButtonUncheckedOutlinedIcon from "@mui/icons-material/RadioButtonUncheckedOutlined";
import type { MenuProps } from "@mui/material";
import { Divider, ListItemIcon, ListItemText, ListSubheader, Menu, MenuItem } from "@mui/material";
import ExportMenuItem from "../../builder/common/exports/ExportMenuItem.tsx";
import type { ExportOption } from "./exportOptions.tsx";
import type { ExportValueSettings } from "./exportTypes.ts";

const exportValueOptions = [
  {
    label: "Full precision",
    description: "Values keep all decimals, including those hidden in the report.",
    exportValuesAsDisplayed: false,
  },
  {
    label: "As displayed",
    description: "Values are rounded to match the report, including abbreviations like K and M.",
    exportValuesAsDisplayed: true,
  },
];

interface Props extends Pick<MenuProps, "anchorEl" | "open" | "anchorOrigin" | "transformOrigin"> {
  options: ExportOption[];
  valueSettings?: ExportValueSettings;
  disabled?: boolean;
  onClose: () => void;
}

const ExportOptionsMenu = ({ options, valueSettings, disabled, onClose, ...menuProps }: Props) => (
  <Menu {...menuProps} onClose={onClose} slotProps={{ paper: { sx: { width: valueSettings ? 308 : undefined } } }}>
    {valueSettings && <ListSubheader sx={{ pb: 1, bgcolor: "transparent" }}>Export values</ListSubheader>}
    {valueSettings &&
      exportValueOptions.map(({ label, description, exportValuesAsDisplayed }) => (
        <MenuItem
          key={label}
          role="menuitemradio"
          disabled={disabled}
          aria-checked={valueSettings.value === exportValuesAsDisplayed}
          onClick={() => valueSettings.onChange(exportValuesAsDisplayed)}
        >
          <ListItemIcon>
            {valueSettings.value === exportValuesAsDisplayed ? (
              <RadioButtonCheckedOutlinedIcon color="primary" />
            ) : (
              <RadioButtonUncheckedOutlinedIcon />
            )}
          </ListItemIcon>
          <ListItemText
            primary={label}
            secondary={description}
            slotProps={{
              primary: { variant: "subtitle2" },
              secondary: { variant: "caption", sx: { display: "block", whiteSpace: "normal" } },
            }}
          />
        </MenuItem>
      ))}
    {valueSettings && <Divider style={{ marginTop: 8, marginBottom: 8 }} />}
    {options.map((option) => (
      <ExportMenuItem
        key={option.key}
        title={option.title}
        Icon={option.Icon}
        onClick={() => {
          onClose();
          option.onClick();
        }}
      />
    ))}
  </Menu>
);

export default ExportOptionsMenu;
